export default "/images/manual.png?8a4265cb276dad9e307b9475f354642d";